var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLogoWhiteDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 80C160 124.183 124.183 160 80 160H29.7143C27.1896 160 25.1429 157.953 25.1429 155.429C25.1429 152.904 27.1896 150.857 29.7143 150.857H34.5143C35.7766 150.857 36.8 149.834 36.8 148.571C36.8 147.846 36.4883 147.147 35.9354 146.781C14.2827 132.465 0 107.9 0 80C0 35.8172 35.8172 0 80 0C124.183 0 160 35.8172 160 80ZM70.5058 70.5082L46.333 79.7043L37.4932 71.9225C35.057 69.7772 31.5628 69.3217 28.6563 70.7705L28.0715 71.0614C27.3251 71.4346 26.9989 72.3251 27.328 73.0892L36.1039 93.5474C37.3487 96.9063 40.5815 99.3002 44.3734 99.3002C45.6673 99.3002 46.8962 99.0214 48.0031 98.5207L76.9767 87.307L74.2201 125.716H77.3643C81.493 125.716 85.1808 123.097 86.5766 119.175L101.308 77.8901L127.442 67.7753L127.427 67.734C130.689 66.4409 132.995 63.2573 132.995 59.5351C132.995 54.6659 129.048 50.7188 124.179 50.7188C123.15 50.7188 122.163 50.8949 121.245 51.2188L121.241 51.2069L94.7988 61.2663L58.4279 44.3689C54.6129 42.5965 50.084 43.3789 47.1028 46.3252L44.8324 48.5689L70.5058 70.5082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogoWhiteDev);
export default __webpack_public_path__ + "static/media/app-logo-white-dev.674971bd53b08b64d444e9d309bb8d77.svg";
export { ForwardRef as ReactComponent };